import { render } from "./SignUpComponent.vue?vue&type=template&id=0ad86313"
import script from "./SignUpComponent.vue?vue&type=script&lang=js"
export * from "./SignUpComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__